import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment-timezone';
import {CUSTOMER_INQUIRY_CATEGORIES, INQUIRY_STATUSES} from '../../../actions/customerInquiry.actions';
import {Table} from '../../Common/PageComponents';

const EmptyInquiry = () => {
  return (
    <tr>
      <td height="26" colSpan="6" align="center">
        Data가 존재하지 않습니다!
      </td>
    </tr>
  );
};

class InquiryTable extends Component {
  render() {
    let inquiries = this.props.inquiries;
    if (!this.props.inquiries) {
      inquiries = [];
    }
    return (
      <div>
        <p className="inquiry">
          {this.props.title}
          <b>{inquiries.length}</b> 건
        </p>
        <Table style={{margin: '10px 0 20px'}}>
          <colgroup>
            <col width="61" />
            <col width="287" />
            <col width="126" />
            <col width="130" />
            <col width="79" />
            <col width="63" />
          </colgroup>
          <thead>
            <tr>
              <th>번호</th>
              <th>제목</th>
              <th>분류구분</th>
              <th>등록일</th>
              <th>답변여부</th>
              <th>확인여부</th>
            </tr>
          </thead>
          <tbody>
            {inquiries.length == 0 ? (
              <EmptyInquiry />
            ) : (
              inquiries.map((inquiry, index) => (
                <tr key={index}>
                  <td>{inquiries.length - index}</td>
                  <td className="left">
                    <Link to={`/customer/inquiries/detail/${inquiry.id}`}>{inquiry.title}</Link>
                  </td>
                  <td>{CUSTOMER_INQUIRY_CATEGORIES[inquiry.category]}</td>
                  <td>{moment(inquiry.created).format('YYYY-MM-DD')}</td>
                  <td>{INQUIRY_STATUSES[inquiry.status]}</td>
                  <td></td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default InquiryTable;
